export const SIMAElementClassifier = {
    COMMENT: "Z00",
    COMMENT_HEADER: "Z01",
    FILE_ATTRIBUTE: "G00",
    SURVEY_POINT_BEGIN: "A00",
    SURVEY_POINT_COORD: "A01",
    SURVEY_POINT_END: "A99",
    ROUTE_BEGIN: "F00",
    ROUTE_TANGENT: "F01",
    ROUTE_ATTRIBUTES: "F03",
    ROUTE_END: "F99",
    ROUTE_COORD: "B01",
    ROUTE_COORD_ADDITIONAL_DISTANCE: "B03",
    CURVE_BEGIN: "C00",
    SIMPLE_CURVE: "C01",
    CLOTHOID_CURVE: "C02",
    CURVE_END: "C99",
    PARCEL_BEGIN: "D00",
    PARCEL_POINT: "D01",
    PARCEL_END: "D99",
    TRIANGULATION_BEGIN: "E00",
    TRIANGULATION_VERTEX: "E01",
    TRIANGULATION_DIMENSION: "E03",
    TRIANGULATION_END: "E99",
    PROFILE_BEGIN: "H00",
    PROFILE_POINT: "H01",
    PROFILE_END: "H99",
    CROSS_SECTION_BEGIN: "I00",
    CROSS_SECTION_CENTER: "I01",
    CROSS_SECTION_POINT: "I02",
    CROSS_SECTION_END: "I99",
};
export const SIMARouteType = {
    IP_LINE: 1,
    MAIN_LINE: 2,
    CENTRAL_LINE: 3,
    LEFT_HAND_MARKER_LINE: 4,
    RIGHT_HAND_MARKER_LINE: 5,
    CONTINUOUS_LINE: 6,
    CONTINUOUS_LINE_WITH_CURVES: 7,
};
export const SIMAParcelType = {
    CLOSED: 1,
    OPEN: 2,
};
export const SIMAProfilePointType = {
    REGULAR: 1,
    CHANGE_POINT: 2,
};
//# sourceMappingURL=types.js.map